// Two answers to "can this device hover?", read once on mount (false / true until
// then, so SSR and the first paint take the safe branch).
//
// - `anyPointerHover`: some attached device can hover precisely
//   (`any-hover` / `any-pointer`). A touchscreen laptop with a trackpad reports
//   touch as the *primary* pointer, so the primary-only query would lose a mouse
//   user the hover flyouts. The cart flyout uses this one, an intentional
//   improvement over nuxt2.
// - `primaryHover`: the primary input hovers (`hover: hover`), nuxt2's query. The
//   nav menus use it so that a tap on a touch-primary device opens the menu on
//   click instead of on the synthetic mouseenter that would toggle it shut. A
//   hybrid device therefore taps rather than hovers the nav menus; that is
//   nuxt2's behaviour and is kept deliberately. AB#63678
export const useHoverCapability = () => {
  const anyPointerHover = ref(false)
  const primaryHover = ref(true)
  onMounted(() => {
    anyPointerHover.value = window.matchMedia?.('(any-hover: hover) and (any-pointer: fine)').matches ?? false
    primaryHover.value = window.matchMedia?.('(hover: hover)').matches ?? true
  })
  return { anyPointerHover, primaryHover }
}
